export default {
  highcharts: {
    decimalPoint: ',',
    downloadJPEG: 'Pobierz obraz JPEG',
    downloadPDF: 'Pobierz dokument PDF',
    downloadPNG: 'Pobierz obraz PNG',
    downloadSVG: 'Pobierz obraz SVG',
    exportButtonTitle: 'Eksport',
    forexRate: 'Kurs średni FOREX',
    loading: 'Ładowanie...',
    months: [
      'Styczeń',
      'Luty',
      'Marzec',
      'Kwiecień',
      'Maj',
      'Czerwiec',
      'Lipiec',
      'Sierpień',
      'Wrzesień',
      'Październik',
      'Listopad',
      'Grudzień',
    ],
    printButtonTitle: 'Drukowanie',
    rangeSelectorFrom: 'Od',
    rangeSelectorTo: 'Do',
    rangeSelectorZoom: 'Przybliżenie',
    rateTypes: {
      ask: 'Najlepsza oferta sprzedaży',
      bid: 'Najlepsza oferta kupna',
      forex: 'Średni kurs na świecie',
    },
    resetZoom: 'Reset',
    resetZoomTitle: 'Reset',
    shortMonths: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru'],
    thousandsSep: ' ',
    weekdays: ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'],
    wtBestAsk: 'Najlepsza oferta sprzedaży',
    wtBestBid: 'Najlepsza oferta kupna',
  },
  calculator: {
    title: 'Einsparungen im Walutomat berechnen',
    rangeFrom: 'Ich möchte',
    forBuy: 'für',
    forSell: 'an',
    directionBuy: 'Kaufen',
    directionSell: 'Verkaufen',
    payText: 'Sie zahlen',
    sellText: 'Sie erhalten',
    buySelect: 'Kaufen',
    sellSelect: 'Verkaufen',
    rateText: 'Wechselkurs',
    amountText: 'Betrag',
    includes: 'Enthält',
    commission: '{{commission}}% Provision',
    howItWorks: '',
    banksComapreOpen: 'Mit anderen vergleichen',
    banksComapreClose: 'Liste minimieren',
    savingsMonthly: 'Sie sparen sogar einmal mit Walutomat',
    savingsYearly: 'ersetzt das ganze Jahr über, jeden Monat.',
    conjunction: 'und',
    serverError: 'Server-Kommunikationsfehler',
    unsupportedPair: 'Wir bieten derzeit keine Kurse für das ausgewählte Währungspaar an.',
    infoError: {
      exchange: 'Bei Walutomat.pl können Sie direkt umtauschen',
      transactionFee:
        'und zurück. Eine solche Transaktion bei der Bank ist mit einer hohen Gebühr verbunden, die in der Regel sogar 5-10 % des Umtauschbetrags erreicht.',
    },
    spinnerError: 'Beim Herunterladen der Daten ist ein Fehler aufgetreten',
  },
  dashboard: {
    canEditPost: 'Możesz edytować wpis',
    postExists: 'Wpis o takim tytule już istnieje',
    postNotExists: 'Wpis o takim tytule nie istnieje',
    emptyPostTitle: 'Dodaj tytuł wpisu',
    error: 'Coś poszło nie tak :(',
  },
  widgetCalculator: {
    title:
      'Überprüfen Sie die Kurse und{{nbsp}}tauschen Sie Währungen in{{nbsp}}Walutomat – schnell und{{nbsp}}günstig.',
    actualRate: 'Wechselkurs',
    exchangeAmount: 'Wechselbetrag',
    buySelect: 'Ich kaufe',
    sellSelect: 'Verkaufen',
    buttonText: 'Umtauschen',
  },
  formValidation: {
    emptyField: 'Das Feld darf nicht leer sein',
    requiredField: 'Das Feld ist Pflichtfeld',
    passwordToShort: 'Das Passwort muss 8 Zeichen lang sein',
    emailNotValid: 'Das Feld muss eine gültige E-Mail Adresse enthalten',
    emailReserved: 'Die E-Mail-Adresse ist bereits vergeben',
    rateEmpty: 'Alle Felder müssen ausgefüllt werden',
    serverUnknownError: 'Kommunikationsfehler des Servers',
    invalidCharacters: 'Feld enthält ungültige Zeichen',
    phoneNotValid: 'Die Telefonnummer ist falsch',
    checkBoxBelow: 'Bitte kreuzen Sie das Feld unten an, um eine Nachricht zu senden',
  },
  password: {
    show: 'anzeigen',
    hide: 'ausblenden',
  },
  howItWorks: {
    showButton: 'Mehr anzeigen',
    hideButton: 'Weniger anzeigen',
  },
}
